import {DataService} from '../Services/data.service';
import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {WebSocketService} from '../Services/webSocket.service';
import {NgbCalendar, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Person} from '../Model/Person';
import {PersonLunch} from '../Model/PersonLunch';
import {
  isWeekend
} from 'date-fns';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';

@Component({
  selector: 'app-secretariaat',
  templateUrl: './secretary.component.html',
  styleUrls: ['./secretary.component.css'],
})

export class SecretaryComponent implements OnInit {
  personLunchesWithGuests;
  timeout;
  searching = false;
  searchResults= [];
  searchCriteria = '';
  searchedPerson: Person;
  guestAmount;
  guestCompany;
  today: NgbDate;
  sendDay: NgbDate;
  isFuture;
  months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
  daysInWeek = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];


  @ViewChild('content') addPersonModal: TemplateRef<any>;

  constructor(private dataService: DataService, public webSocketService: WebSocketService, private router: Router, private calendar: NgbCalendar) {
    this.today = calendar.getToday();
  }

  /**
   * check the role of the currently logged in {@link Person}
   * if {@link Person} doesn't has role 6 ('Kantine/Canteen') the user will be redirected to the login screen
   */
  checkRole(): void {
    if (this.dataService.role.id !== 6) {
      this.router.navigateByUrl('aanmelden');
    }
  }

  /**
   * on Init the date in variable Today will be set to today's date
   * The Role of the user will be check with {@link checkRole}
   * all {@link PersonLunch} will be get where the guest amount is not 0
   */
  ngOnInit(): void {
    console.log(this.today);
    this.personLunchesWithGuests = [];
    console.log(this.dataService.role);
    this.checkRole();
    this.getGuestsWithTodayDate();
  }

  /**
   * Get the guests of today
   * Function will return {@link PersonLunch} where guests is not 0
   */
  getGuestsWithTodayDate(): void {
    console.log(this.today);
    if(this.today.day < new Date().getDate()) {
      this.isFuture = false;
    } else {
      this.isFuture = true;
    }
    this.dataService.getGuests(this.ngbDateToDate(this.today)).then((response) => {
      this.personLunchesWithGuests = response;
    });
  }

  /**
   * nextDay will set the date of 'today' to the next day of the week
   * If the date is on saturday or sunday, nextDay will be called again (Recursive until the date is not in the weekend)
   */
  nextDay(): void {
    this.today.day = this.today.day + 1;

    if(isWeekend(this.ngbDateToDate(this.today))) {
      return this.nextDay();
    }
    this.getGuestsWithTodayDate();
  }


  /**
   * previousDay will set the date of 'today' to the previous day of the week
   * If the date is on saturday or sunday, previousDay will be called again (Recursive until the date is not in the weekend)
   */
  previousDay(): void {
    this.today.day = this.today.day - 1;
    if(isWeekend(this.ngbDateToDate(this.today))) {
     return this.previousDay();
    }
    this.getGuestsWithTodayDate();
  }

  /**
   * search will search for a {@link Person} with the given searchCriteria
   * search a person, will trigger on typing
   * if person stops typing for 500ms, the request will be send
   * checks if the textinput length is more that 1
   * send request to dataservice which will send it to the server
   */

  search(): void {
    // Clear the timeout if it has already been set.
    // This will prevent the previous task from executing
    // if it has been less than <MILLISECONDS>
    clearTimeout(this.timeout);
    const textInput = this.searchCriteria;
    const that = this;
    console.log(textInput);
    if(textInput.length < 1) {
      return;
    }
    // Make a new timeout set to go off in 800ms
    this.timeout = setTimeout(function () {
      console.log('Input Value:', textInput);
      that.searching = true;
      that.dataService.searchPerson(textInput).then((response) => {
        console.log(response);
        that.searchResults = response;
        that.searching = false;
      });
    }, 500);
  }

  /**
   * addPerson will add guest to a PersonLunch from a searched person
   * After adding the person all values in the form will be reset
   */
  addPerson(): void {
    console.log(this.guestAmount);
    if(this.guestAmount > 0 && this.guestCompany != null && this.searchedPerson.name != '') {
      this.dataService.addGuests(this.guestAmount, this.guestCompany, this.searchedPerson, this.ngbDateToDate(this.today)).then((response) => {
        console.log(response);
        console.log(this.personLunchesWithGuests.length);
        this.personLunchesWithGuests.push(response);
        console.log(this.personLunchesWithGuests.length);

      });
      this.searchCriteria = '';
      this.guestAmount = 0;
      this.guestCompany = '';
      this.searchedPerson = null;
    } else {
      alert('Vul alle vakjes in!');
    }
  }

    addPersonToLunch(): void {
        if(this.searchedPerson.name != '') {
          this.sendDay = this.today;
          this.sendDay.day = this.sendDay.day +1;
            this.dataService.addPersonDefinitivePerDate(this.searchedPerson, this.ngbDateToDate(this.sendDay)).then((response) => {
                console.log(response);
                console.log(this.personLunchesWithGuests.length);
                this.personLunchesWithGuests.push(response);
                console.log(this.personLunchesWithGuests.length);

            });
            this.searchCriteria = '';
            this.guestAmount = 0;
            this.guestCompany = '';
            this.searchedPerson = null;
        } else {
            alert('Vul persoon in!');
        }
        this.today.day = this.today.day -1;
    }

  /**
   * Add the searched {@link Person} to the {@link searchedPerson} variable
   * Will be saved to this variable until the user tries to find a new user or when the user adds the guest to the {@link searchedPerson}
   * @param {Person} user
   */
  addSearchedUser(user: Person): void {
    this.searchedPerson = user;
    this.searchCriteria = '';
    this.searchResults = [];
  }

  /**
   * Remove the guest from a {@link PersonLunch}
   * @param personLunch from where the guest should be removed
   */
  removeGuest(personLunch): void {
    console.log(personLunch);
    this.dataService.removeGuest(personLunch).then((response) => {
      console.log(response);
      for(let i = 0; i<this.personLunchesWithGuests.length; i++){
        if(this.personLunchesWithGuests[i] === personLunch){
          this.personLunchesWithGuests.splice(i, 1);
        }
      }
    })

  }

  /**
   * transform the NgbDate to a normal Date type
   * @param {NgbDate} date
   * @returns {Date}
   */
  ngbDateToDate(date: NgbDate): Date {
    return new Date(date.year, date.month - 1, date.day);
  }
}



// WEBPACK FOOTER //
// ./src/app/Secretary/secretary.component.ts